import types from "./action-types";

const profileService = abp.services.api.profileService;
const nominalProfileService = abp.services.api.nominalProfileService;

const profileActions = {
  refreshData: () => {
    return (dispatch, getState) => {
      const { profileId, nominalProfileId } = getState().profile;

      // reload is relevant only for nominal
      loadDataInternal(dispatch, profileId, nominalProfileId, true, "_");
    };
  },
  loadData: (profileId, nominalProfileId, isNominalProfile, id) => {
    return (dispatch, getState) => {
      loadDataInternal(
        dispatch,
        profileId,
        nominalProfileId,
        isNominalProfile,
        id
      );
    };
  },
};

const loadDataInternal = (
  dispatch,
  profileId,
  nominalProfileId,
  isNominalProfile,
  id
) => {
  const apiMethod = isNominalProfile
    ? nominalProfileService.getNominalProfileChart
    : profileService.getProfileChart;

  apiMethod(profileId || null, nominalProfileId).done((result) => {
    dispatch({
      type: types.DATA_LOADED,
      data: { id, profileId, nominalProfileId, dataSets: result.dataSets },
    });
  });
};

export default profileActions;



// WEBPACK FOOTER //
// ./App/components/modules/profile/actions.js